module.exports = __webpack_public_path__ + "img/mariadb.ba234b66.png";